import unescape from 'unescape';
import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ButtonDownloadPhoto from './ButtonDownloadPhoto';
import ButtonEdit from './ButtonEdit';
import Safety from './Safety';
import StandardLicense from './StandardLicense';
import LoginAndSignup from './LoginAndSignup';
import StripePaymentForm from './StripePaymentForm/Loadable';
import ExtraLicenseNew from './ExtraLicense';
import ButtonEditIllust from './ButtonEditIllust';
import ButtonDownloadIllust from './ButtonDownloadIllust';
import AssetsSize from '../AssetsSize';
import ModalShare from '../ModalShare';
import CircleProgress from '~/components/CircleProgress';
import GoogleAds from '~/components/GoogleAdsNew';
import Cookies from '~/services/Cookies';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import IconClose from '~/components/svg/icon-x.svg';
import IconExtraLicense from '~/components/svg/extra-license.svg';
import Config from '~/config';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';
import { OPEN_MODAL } from '~/containers/ErrorMessageModal/constants';
import { makeSelectCurrentLanguage } from '~/containers/Language/selectors';
import { loadingHide, loadingShow } from '~/containers/Loading/actions';
import {
  makeSelectLoading,
  makeSelectMessage,
} from '~/containers/Loading/selectors';
import { makeSelectPrices } from '~/containers/PaymentModal/selectors';
import ButtonAddCartContainer from '~/containers/PhotoCart/ButtonAddCartContainer';
import {
  assetSelect,
  assetSelectIndex,
  downloadPhoto,
  hideGotIt,
  nicePhoto,
  openEditor,
  showAttributeModal,
  showPhotoVoting,
} from '~/containers/PhotoPage/actions';
import PhotoVoting from '~/containers/PhotoPage/PhotoVoting/Loadable';
import {
  makeSelectAssetSelected,
  makeSelectDownloadingPhoto,
  makeSelectDownloadPhotoLoading,
  makeSelectId,
  makeSelectOpeningEditor,
  makeSelectPhotoAssets,
  makeSelectPhotoNice,
  selectDetailPhoto,
} from '~/containers/PhotoPage/selectors';
import * as paymentService from '~/services/payment';
import { device, urls } from '~/utils';
import { USER_ROLES } from '~/utils/constants';
import { makeSelectIsLocaleInPath } from '~/containers/MetadataProvider/selectors';
import { updateDataCountSurvey } from '~/containers/Layout/actions';
import { selectLayout } from '~/containers/Layout/selectors';
import IconInfo from '~/components/svg/icon-info.svg';
import IconInfoSvg from '~/components/svg/info-icon.svg';
import IconYesIllustAC from '~/components/FreeAndPremiumCompareTable/icon-yes-ill.svg';
import themeVariables from '~/shared/themeVariables';

const COUNTDOWN_DOWNLOAD = 5; // in seconds
const roles = Config.getRoles();

// TODO: Clean code of this component.
@withI18next()
class PhotoDownloadFreeMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      credit: false,
      openModalShare: false,
      messageError: false,
      time: COUNTDOWN_DOWNLOAD,
      loadingModalTimer: true,
      showModalTimer: false,
      showAssets: false,
      showCopySuccess: false,
      isAvailableBatchDownload: true,
      openExtraLicenseForm: false,
    };
    this.timer = null;
  }

  componentDidMount() {
    const { id } = this.props;
    const dataSelect = Cookies.get('photo_select_asset')
      ? JSON.parse(Cookies.get('photo_select_asset'))
      : null;
    if (dataSelect) {
      const index = dataSelect.index;
      const idPhoto = dataSelect.id;
      if (idPhoto === id) {
        this.props.assetSelectIndex(index);
        this.props.assetSelect(index);
      }
    }
  }

  startDownloadingCountdownTimer = () => {
    this.timer = setInterval(this.tick, 1000);
  };

  stopDownloadingCountdownTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  tick = () => {
    const { id, assets, assetSelected, downloadPhoto, profile } = this.props;

    this.setState({ time: this.state.time - 1 }, () => {
      if (this.state.time === 0) {
        this.stopDownloadingCountdownTimer();
        this.setState({
          loadingModalTimer: false,
        });
        if (Config.isIllustAC()) {
          downloadPhoto({
            id,
            type: assets[assetSelected].type,
            format: assets[assetSelected].format,
            paymentID: '',
            payerID: '',
            paymentToken: '',
            userIdforLog: profile.user_id,
          });
        }
      }
    });
  };

  closeModal = () => {
    this.stopDownloadingCountdownTimer();
    this.setState({
      showModalTimer: false,
      time: COUNTDOWN_DOWNLOAD,
    });
  };

  onAssetsSizeSelect = (asset, index) => {
    const { lng, id, assets, assetSelected } = this.props;

    const dataSelect = {
      id: id,
      assetSelected: assets[assetSelected],
      index: index,
    };

    Cookies.set('photo_select_asset', JSON.stringify(dataSelect));
    if (this.props.role === roles.CREATOR && Config.isCreatorAvailable(lng)) {
      this.onShowModalWarning();
      return;
    }

    if (Config.serviceType !== 'design_ac') {
      if (this.props.isAuthenticated && this.props.role !== roles.CREATOR) {
        if (asset.price.with_tax === 0) {
          this.setState(
            {
              credit: false,
              isAvailableBatchDownload: true,
            },
            () => {
              this.props.assetSelectIndex(index);
              return this.props.assetSelect(index);
            },
          );
        } else {
          this.setState(
            {
              credit: true,
              isAvailableBatchDownload: false,
            },
            () => {
              this.props.assetSelectIndex(index);
              return this.props.assetSelect(index);
            },
          );
        }
      } else {
        return this.props.assetSelect(index);
      }
    } else {
      if (asset.price.with_tax === 0 || this.props.isAuthenticated) {
        this.props.assetSelectIndex(index);
        return this.props.assetSelect(index);
      } else {
        return this.props.assetSelect(index);
      }
    }
  };

  nicePhoto = () => {
    const { nicePhoto, id } = this.props;
    nicePhoto(id);
  };

  onOpenEditor = () => {
    const { id, assets, assetSelected, t, lng, openEditor } = this.props;
    if (!assets || !assets[assetSelected]) return;

    let params;
    if (Config.isPhotoAC() || Config.isIllustAC()) {
      let editorLng = lng;
      const editorACLanguages = ['en', 'vi', 'tw', 'ko'];
      if (!editorACLanguages.includes(editorLng)) {
        editorLng = 'en';
      }
      if (
        assets[assetSelected].format === 'PNG' ||
        assets[assetSelected].format === 'JPG' ||
        assets[assetSelected].format === 'JPEG'
      ) {
        params = {
          id,
          type: assets[assetSelected].type,
          format: assets[assetSelected].format,
          message: t('message_notify_download_completed'),
        };
      }
    }

    if (params) {
      openEditor(params, 'download');
    }
  };

  onDownload = () => {
    const {
      id,
      assets,
      assetSelected,
      onToggleSupportMessage,
      downloadPhoto,
      profile,
    } = this.props;

    if (!assets || !assets[assetSelected]) return;
    setTimeout(onToggleSupportMessage, 1000);

    this.setState(
      (state) => ({
        showModalTimer: !state.showModalTimer,
      }),
      this.startDownloadingCountdownTimer,
    );

    if (Config.isIllustAC()) return;

    downloadPhoto({
      id,
      type: assets[assetSelected].type,
      format: assets[assetSelected].format,
      paymentID: '',
      payerID: '',
      paymentToken: '',
      userIdforLog: profile.user_id,
    });
  };

  onEdit = () => {
    const { id, assets, assetSelected, openEditor } = this.props;
    if (!assets || !assets[assetSelected]) return;
    openEditor({
      id,
      type: assets[assetSelected].type,
      format: assets[assetSelected].format,
    });
  };

  onShowModalWarning = () => {
    const { t, lng } = this.props;
    this.props.showModalWarning({
      title: t('you_cannot_download_as_creator'),
      description: t('logout_and_use_downloader', {
        loginURL: `${
          Config.ssoServerUrl
        }/login?lang=${lng}&serviceURL=${encodeURIComponent(
          window.location.href,
        )}`,
      }),
    });
  };

  handleDownLoad = () => {
    this.setState({
      showModalTimer: false,
      loadingModalTimer: true,
      time: COUNTDOWN_DOWNLOAD,
    });
    // todo: open to direct to designac
    // this.onOpenEditor();
    this.onDownload();
  };

  payStripe = (data) => {
    this.props.loadingShow({
      message: this.props.t('register_premium_message_pay'),
    });
    const opts = {
      id: this.props.id,
      itemSelect: this.props.assets[this.props.assetSelected],
      currency: 'USD',
      stripeToken: data.token.id,
    };

    return paymentService
      .paymentByStripe(opts)
      .then((res) => {
        this.props.loadingHide();
        window.location.href = res.link;
      })
      .catch(() => {
        this.setState({ messageError: true });
        this.props.loadingHide();
      });
  };

  onSocialShare = (link) => {
    window.open(
      link,
      'share',
      `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${
        window.innerWidth / 2 - 225
      }, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
    );
  };

  onSocialShareClosed = () => {
    this.setState({ openModalShare: false });
  };

  onSocialShareShared = () => {
    this.setState({ openModalShare: false });
    this.onDownload();
  };

  isPremiumItem(item) {
    return !(item && item.price && item.price.with_tax === 0);
  }

  redirectLogin = () => {
    const { lng } = this.props;
    window.location.href = `${
      Config.ssoServerUrl
    }/login?lang=${lng}&serviceURL=${encodeURIComponent(
      process.browser ? window.location.href : '',
    )}`;
  };

  handleDownloadAsset = () => {
    const { assets, assetSelected, isAuthenticated, profile } = this.props;

    if (!isAuthenticated || profile.role === USER_ROLES.CREATOR) {
      this.redirectLogin();
      return;
    }

    if (this.isPremiumItem(assets[assetSelected])) {
      this.setState({
        credit: true,
      });
    } else {
      this.handleDownLoad();
    }
  };

  handleEdit = () => {
    const { assets, assetSelected, isAuthenticated } = this.props;

    if (!isAuthenticated) {
      this.redirectLogin();
    }
    if (this.isPremiumItem(assets[assetSelected])) {
      this.setState({ credit: true });
    } else {
      this.onEdit();
    }
  };

  renderModalDownload = () => {
    const { showModalTimer, loadingModalTimer, time } = this.state;
    const { t } = this.props;

    return (
      <Modal
        // show={true}
        show={showModalTimer}
        onHide={this.closeModal}
        id="modal-before-download"
        dialogClassName="modal-before-download"
      >
        <Modal.Body>
          <div className="modal-before-download-body">
            <div className="download-ads">
              {/* TODO: check google ads */}
              <GoogleAds />
            </div>
            {/* loadingModalTimer */}
            {loadingModalTimer ? (
              <div className="download-loading">
                <h3>{t('starting_download')}</h3>
                <CircleProgress
                  number={time}
                  percentage={(time / COUNTDOWN_DOWNLOAD) * 100}
                  color={'#E3E3E3'}
                />
              </div>
            ) : (
              <div className="download-benefit">
                <div className="title-download-benefit">
                  {t('modal_download_title')}
                </div>
                <div className="sub-title-download-benefit">
                  {t('upgrade_to_premium')}
                </div>
                <div className="upgrade-reason">
                  <span className="icon">
                    <IconYesIllustAC />
                  </span>
                  <span>{t('upgrade_to_premium_reason_1')}</span>
                </div>
                <div className="upgrade-reason">
                  <span className="icon">
                    <IconYesIllustAC />
                  </span>
                  <span>{t('upgrade_to_premium_reason_2')}</span>
                </div>
                <div className="upgrade-reason">
                  <span className="icon">
                    <IconYesIllustAC />
                  </span>
                  <span>{t('upgrade_to_premium_reason_3')}</span>
                </div>
                <a href="/premium" className="btn-upgrade-premium">
                  {t('upgrade_now')}
                </a>
              </div>
            )}
            <span onClick={this.closeModal} className="btn-close">
              <IconClose />
            </span>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  handleCopy = () => {
    const { t, photo } = this.props;
    const { nickname } = photo.creator;
    this.setState({ showCopySuccess: true });
    const text = t(Config.getPrefixContent('image_by_text'), {
      serviceLink: Config.getSiteURL(),
      imageLink: window.location.href,
      creatorName: nickname,
    });
    if (window.navigator && window.navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      device.copyToClipboard(text);
    }
  };

  renderEditButton = () => {
    const { assets, assetSelected, openingEditor, profile, t } = this.props;
    let isSelectVectorFile = false;
    if (Config.isDesignAC()) return;

    const currentSelectedItem = assets[assetSelected];
    if (!currentSelectedItem) return;

    if (
      currentSelectedItem &&
      (currentSelectedItem.type === 'AI' ||
        currentSelectedItem.type === 'EPS' ||
        currentSelectedItem.type === 'SVG')
    ) {
      isSelectVectorFile = true;
    }
    if (this.state.credit) {
      return;
    }

    if (Config.isIllustAC())
      return (
        <ButtonEditIllust
          loading={openingEditor}
          onClick={this.handleEdit}
          isFreeUser
          role={profile.role}
          t={t}
          isSelectVectorFile={isSelectVectorFile}
        />
      );

    if (isSelectVectorFile) return;

    return (
      <ButtonEdit
        loading={openingEditor}
        onClick={this.handleEdit}
        isFreeUser
        role={profile.role}
      />
    );
  };

  renderStripePayment = () => {
    return (
      <StripePaymentForm
        credit={this.state.credit}
        payStripe={this.payStripe}
        messageError={this.state.messageError}
      />
    );
  };

  renderImageInformation = () => {
    const { t, photo, lng } = this.props;
    const { nickname_for_overseas, nickname } = photo.creator;
    const title = Config.getTitleByLanguage(photo.title, lng);
    const validateTitle = title.replace('&amp;', '&');

    return (
      <>
        <div className="container-image-infor">
          <span className="icon-image-infor">
            <IconInfo />
          </span>
          <div className="content-image-infor">
            {t(Config.getPrefixContent('image_information'))}
          </div>
        </div>
        <div className="data-image-container">
          <div className="data-image creator">
            <div className="user-infor-name">
              {t('creator')}:{/* TODO: REMOVE THIS COMMENT */}
              {/* {photo.creator.id ? (
                <I18nLink href={`/creator-profile/${photo.creator.id}`}>
                  <a target="_blank" className={'link-creator-infor'}>
                    {nickname_for_overseas || nickname || photo.user_name}
                  </a>
                </I18nLink>
              ) : ( */}
              {nickname_for_overseas || nickname || photo.user_name}
              {/* )} */}
            </div>
          </div>
          <div className="data-image">
            {t('title')}: {unescape(title)}
          </div>
          <div className="data-image">
            {t(Config.getPrefixContent('image_id'))}: {photo.id}
          </div>
          <div className="data-image">
            {t('download')}: {photo.download_count}
          </div>
          {Config.isPhotoAC() && (
            <>
              <div className="data-image">
                {t('model_release')}:{' '}
                {photo.model_release ? t('available') : t('na')}
              </div>
              <div className="data-image">
                {t('property_release')}:{' '}
                {photo.property_release ? t('available') : t('na')}
              </div>
            </>
          )}
          <div className="data-image category">
            <div className="title-categories-information">
              {t('categories')}:{' '}
            </div>
            <div className="data-categories-information">
              {photo.categories.map((item) => {
                return (
                  <React.Fragment key={item.id}>
                    <I18nLink href={`/category/${item.category_slug}`}>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        className={`link-category link-to ${Config.serviceType}`}
                      >
                        {item.category_name}
                      </a>
                    </I18nLink>
                    {' / '}
                    {validateTitle}
                    <br />
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
        <style jsx>
          {`
            .container-image-infor {
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 48px;
              font-weight: 700;
            }
            .icon-image-infor {
              margin-right: 16px;
              color: '#1b2833';
            }
            .data-image-container {
              display: flex;
              flex-direction: column;
            }
            .data-image {
              font-weight: 500;
              font-size: 16px;
              line-height: 28px;
              margin-top: 8px;
              align-items: center;
              color: #000000;
            }
            .data-image.creator {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            }
            .data-image.category .link-category:hover {
              text-decoration: underline !important;
              opacity: 0.9;
            }
            .user-follow {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              border: 2px solid #1b2833;
              box-sizing: border-box;
              border-radius: 4px;
              align-items: center;
              padding: 2px 8px;
              color: #000000;
            }
            .user-follow-icon {
              margin-right: 4px;
            }
            .user-follow-text {
              display: contents;
            }
            .data-image.category {
              display: flex;
              width: 100%;
              align-items: flex-start;
            }
            .title-categories-information {
              min-width: 100px;
            }
            .link-category {
              font-weight: 700;
            }
            .link-creator-infor:hover {
              text-decoration: underline !important;
            }
            .link-creator-infor {
              font-weight: 700;
            }
          `}
        </style>
      </>
    );
  };

  render() {
    const { credit, openModalShare } = this.state;
    const {
      downloadPhotoLoading,
      assets,
      assetSelected,
      t,
      lng,
      isAuthenticated,
      photo,
      currentLanguage,
      // openingEditor,
      photoDetail,
      onToggleSupportMessage,
      isLocaleInPath,
      role,
    } = this.props;
    // const keywords = Config.getTitleByLanguage(photo.title, currentLanguage);
    // const creator = photo.creator.nickname;
    // const tags = uniqBy(photo.tags || []);
    // const showBitcoin =
    //   photo.creator.bitcoin_address || photo.creator.bitcoin_address === 'NULL';

    // const popoverTop = (
    //   <Popover id="donate-popover-positioned-top">
    //     <div className="text-center">
    //       <h4>{t('donate_bitcoins_title')}</h4>
    //       <QCodeComponent value={photo.creator.bitcoin_address} />
    //       <p>{photo.creator.bitcoin_address}</p>
    //     </div>
    //   </Popover>
    // );
    // const noBitcoin = {
    //   width: '170px',
    // };

    return (
      <div className="download-free">
        <div className="button-photo-download-detail">
          <AssetsSize
            photo={photo}
            assets={assets}
            itemSelect={assets[assetSelected]}
            onSelectItem={this.onAssetsSizeSelect}
          />
          {Config.isIllustAC() ? (
            <ButtonDownloadIllust
              onClick={this.handleDownloadAsset}
              isPremium={this.isPremiumItem(assets[0])}
              loading={downloadPhotoLoading}
              role={role}
              t={t}
            />
          ) : (
            <ButtonDownloadPhoto
              onClick={this.handleDownloadAsset}
              isPremium={this.isPremiumItem(assets[0])}
              loading={downloadPhotoLoading}
            />
          )}

          {credit && this.renderStripePayment()}
          <div className="button-photo-download-action-group">
            {this.state.isAvailableBatchDownload && (
              <ButtonAddCartContainer
                isAuthenticated={isAuthenticated}
                sizeSelect={assets[assetSelected]}
                photo={photo}
              />
            )}
            {this.renderEditButton()}
          </div>
          {!isAuthenticated && <LoginAndSignup t={t} lng={lng} />}

          {Config.isIllustAC() ? (
            <>
              <div
                className="upgrade-bulk-download"
                dangerouslySetInnerHTML={{
                  __html: t('upgrade_bulk_download', {
                    premiumLink: '/premium',
                  }),
                }}
              />
              <div
                className="upgrade-bulk-download-mobile"
                dangerouslySetInnerHTML={{
                  __html: t('upgrade_bulk_download_mobile', {
                    premiumLink: '/premium',
                  }),
                }}
              />
              <div className="photo-creator-info">
                <span className="photo-creator-info-title">{t('creator')}</span>
                <img
                  data-src={photo.creator?.avatar || urls.renderAvatarUrl()}
                  className="photo-creator-info-avatar lazyload"
                  alt={photo.user_name || 'creator'}
                />
                {/* TODO: REMOVE THIS COMMENT */}
                {/* <a
                  href={`/creator-profile/${photo.creator.id || photo.user_id}`}
                  className="photo-creator-info-name link-to"
                  target="_blank"
                  rel="noreferrer"
                > */}
                {photo?.creator?.nickname_for_overseas ||
                  photo?.creator?.nickname ||
                  photo.user_name}
                {/* </a> */}
              </div>
              <div className="photo-extra-license">
                <IconExtraLicense />
                <span
                  className="photo-extra-license-link"
                  dangerouslySetInnerHTML={{
                    __html: t('upgrade_extra_license', {
                      extraLicense: '/extra-license',
                      upgradeLink: '/premium',
                    }),
                  }}
                />
              </div>
              <div>
                <div>
                  <IconInfoSvg />
                  <a
                    href="/help-page?tab=usage_guides"
                    className="photo-extra-license-link link-to"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('contact_us_option_category_03')}
                  </a>
                </div>
                <h2 className="photo-extra-license-content">
                  {t('ill_usage_guides')}
                </h2>
              </div>
            </>
          ) : (
            <>
              <StandardLicense
                t={t}
                lng={lng}
                photo={photo}
                currentLanguage={currentLanguage}
              />
              {photo.creator.is_safety && (
                <Safety
                  t={t}
                  lng={lng}
                  photo={photo}
                  isLocaleInPath={isLocaleInPath}
                />
              )}
              {this.renderImageInformation()}
              {photo.has_extra_license && (
                <ExtraLicenseNew photo={photo} t={t} lng={lng} />
              )}
            </>
          )}
        </div>
        {/* <License profile={profile} photo={photo} />
          {Config.serviceType !== 'design_ac' && (
            <ButtonBitcoin
              bitcoinAddress={photo.creator.bitcoin_address}
              className="btn-photo-action"
            />
          )}
        </div>*/}
        {photoDetail.isPhotoVotingVisible && (
          <PhotoVoting onToggleSupportMessage={onToggleSupportMessage} />
        )}
        <ModalShare
          show={openModalShare}
          currentLanguage={currentLanguage}
          onClose={this.onSocialShareClosed}
          onShare={this.onSocialShareShared}
        />
        {Config.isIllustAC() && this.renderModalDownload()}
        <style jsx global>
          {`
            .upgrade-bulk-download {
              font-weight: 700;
              font-size: 16px;
              line-height: 28px;
              margin: 8px 0;
              text-align: center;
            }
            .upgrade-bulk-download-mobile {
              display: none;
              font-weight: 700;
              font-size: 16px;
              line-height: 28px;
              margin: 8px 0;
              text-align: center;
            }
            .button-photo-download-action-group {
              display: ${Config.isIllustAC() ? 'flex' : 'block'};
              justify-content: space-between;
              flex-flow: row-reverse;
            }
            .button-photo-download-detail {
              border-bottom: ${Config.isIllustAC()
                ? 'none'
                : '2px solid #000000'};
            }
            .btn-download-extra-license {
              margin-top: 7px;
            }
            .photo-creator-info {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 120px;
              border-bottom: 1px solid #e3e3e3;
            }
            .photo-creator-info-title {
              font-weight: 700;
              font-size: 16px;
              line-height: 28px;
              color: #170507;
            }
            .photo-creator-info-avatar {
              width: 40px;
              height: 40px;
              border-radius: 99999px;
              margin: 8px 0;
              border: 1px solid #e3e3e3;
            }
            .photo-creator-info-name {
              font-weight: 700;
              font-size: 16px;
              line-height: 28px;
            }
            .photo-extra-license {
              margin: 8px 0;
            }
            .photo-extra-license-link {
              margin-left: 8px;
              font-weight: 700;
            }
            .photo-extra-license-content {
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #170507;
              margin-top: 8px;
            }
            .photo-actions {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            .photo-actions .btn-photo-action:first-child:nth-last-child(2),
            .photo-actions
              .btn-photo-action:first-child:nth-last-child(2)
              ~ .btn-photo-action {
              width: 48%;
            }
            .photo-actions .btn-photo-action:first-child:nth-last-child(3),
            .photo-actions
              .btn-photo-action:first-child:nth-last-child(3)
              ~ .btn-photo-action {
              width: 30%;
            }
            .link-to:hover {
              text-decoration: underline !important;
              opacity: 0.9;
            }
            .link-to {
              font-weight: 700;
            }
            .modal-before-download {
              width: 822px;
              background: #ffffff;
              padding: 32px;
              height: 344px;
            }
            div.fade.in.modal {
              display: flex !important;
            }
            .modal-dialog {
              margin: auto;
            }
            .download-ads {
              min-width: 360px;
              min-height: 280px;
              background: #ffffff;
            }
            .modal-before-download .modal-body {
              padding: 0 !important;
            }
            .modal-before-download-body {
              display: flex;
              position: relative;
            }
            .modal-before-download-body .download-benefit,
            .modal-before-download-body .download-loading {
              display: flex;
              flex-direction: column;
              width: 100%;
            }
            .title-download-benefit {
              font-weight: 600;
              font-size: 24px;
              color: #170507;
              width: 100%;
              display: flex;
              justify-content: center;
              margin-bottom: 24px;
            }
            .sub-title-download-benefit {
              font-style: normal;
              font-weight: 700;
              font-size: 16px;
              line-height: 28px;
              text-align: center;
              color: #170507;
              display: flex;
              justify-content: center;
              margin-bottom: 8px;
            }
            .modal-before-download-body .download-loading {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 32px;
              border-left: 1px solid #e3e3e3;
            }
            .download-loading h3 {
              font-weight: 600;
              font-size: 20px;
              line-height: 23px;
              margin: 0 0 16px;
            }
            .modal-before-download-body .download-benefit {
              width: 330px;
              margin: 0;
              display: flex;
              justify-content: center;
              padding-left: 16px;
              margin-left: 12px;
              border-left: 1px solid #e3e3e3;
            }
            .download-benefit h3 {
              font-weight: 600;
              font-size: 20px;
              line-height: 23px;
              margin: 0 0 16px 0;
              width: 100%;
              display: flex;
            }
            .download-benefit p {
              font-weight: 500;
              font-size: 16px;
              line-height: 28px;
              margin: 0 0 8px 0;
            }

            .download-benefit .btn-upgrade-premium {
              padding: 8px 16px;
              margin: 24px 0 0;
              width: 100%;
              height: 44px;
              background: ${themeVariables.colors.primary};
              border-radius: 40px;
              display: flex;
              justify-content: center;
              color: #ffffff;
              align-items: center;
            }
            .download-benefit .upgrade-reason {
              display: flex;
            }
            .modal-before-download-body .btn-close {
              width: 24px;
              height: 24px;
              position: absolute;
              top: 0;
              font-weight: 700;
              right: 0;
              text-align: center;
              font-size: 18px;
            }
            .modal-before-download-body .btn-close:hover {
              cursor: pointer;
              opacity: 0.8;
            }
            @media (max-width: ${themeVariables.breakpoints.tabletS
                .maxWidth}px) {
              .modal-before-download-body {
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                flex-flow: column-reverse;
              }
              .modal-before-download {
                width: 408px;
                height: auto;
                padding: 4px;
              }
              .modal-before-download-body .download-benefit {
                margin: 0 0 16px;
                align-items: start;
                border-left: none;
              }
              .modal-before-download-body .download-loading {
                margin-left: 0;
                border-left: none;
              }
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .upgrade-bulk-download {
                display: none;
              }
              .upgrade-bulk-download-mobile {
                display: block;
              }
              .download-ads {
                display: none;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  id: makeSelectId(),
  nice: makeSelectPhotoNice(),
  assets: makeSelectPhotoAssets(),
  assetSelected: makeSelectAssetSelected(),
  downloadPhotoLoading: makeSelectDownloadPhotoLoading(),
  downloadingPhoto: makeSelectDownloadingPhoto(),
  prices: makeSelectPrices(),
  loading: makeSelectLoading(),
  message: makeSelectMessage(),
  currentLanguage: makeSelectCurrentLanguage(),
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
  openingEditor: makeSelectOpeningEditor(),
  photoDetail: selectDetailPhoto,
  isLocaleInPath: makeSelectIsLocaleInPath(),
  layout: selectLayout,
});
const mapDispatchToProps = (dispatch) => ({
  assetSelect: (index) => dispatch(assetSelect(index)),
  assetSelectIndex: (index) => dispatch(assetSelectIndex(index)),
  downloadPhoto: (params) => dispatch(downloadPhoto(params)),
  nicePhoto: (id) => dispatch(nicePhoto(id)),
  gotIt: () => dispatch(hideGotIt()),
  loadingShow: (params) => dispatch(loadingShow(params)),
  loadingHide: () => dispatch(loadingHide()),
  showModalWarning: (params) =>
    dispatch({
      type: OPEN_MODAL,
      title: params.title,
      description: params.description,
    }),
  showAttributeModal: (modal) => dispatch(showAttributeModal(modal)),
  openEditor: (params, newWindow) => dispatch(openEditor(params, newWindow)),
  showPhotoVoting: () => dispatch(showPhotoVoting()),
  updateDataCountSurvey: (data) => dispatch(updateDataCountSurvey(data)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PhotoDownloadFreeMember);
